import React, {useContext, useState} from 'react'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import {
    eyeHandler, getLocalStorageItem, getPathAndQueryParams, logging,
    objectLang,
    setErrorWindow, setLocalStorageItem,
    validationEmail,
    validationPassword
} from "../functions"
import config from '../config.json'
import {Link, useNavigate} from "react-router-dom"
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"
import {Button} from "react-bootstrap"

const $ = require("jquery")

export const AuthPageForm = () => {
    setLocalStorageItem('page', 'AuthPageForm')
    const auth = useContext(AuthContext)
    const {loading, request} = useHttp()
    const navigate = useNavigate()
    const [form, setForm] = useState({email: '', password: ''})
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})

    const [deviceId] = useState(() => {
        let id = getLocalStorageItem('deviceId')

        if (!id) {
            id = crypto?.randomUUID?.() ||
                Math.random().toString(36).slice(2) + Date.now().toString(36)
            setLocalStorageItem('deviceId', id)
        }
        return id
    })

    const lang = objectLang().language
    const l = lang.lang

    let widthWin = '600px'
    if (window.matchMedia('(max-width: 768px)').matches) {
        widthWin = window.innerWidth
    }

    const changeHandler = event => {
        const name = event.target.name
        const value = event.target.value
        setForm({...form, [name]: value})
    }

    const sendSmsHandler = async () => {}

    const enterAgainHandler = () => {
        window.location.replace(getPathAndQueryParams())
    }

    const remindPassHandler = () => {
        window.location.replace(`/${l}/restore`)
    }

    const loginHandler = async () => {

        let host
        window.location.host === 'localhost:3000'
            ? host = config.localHost
            : host = config.onrender

        const validPassword = validationPassword(form.password)

        if (!validPassword.flag) {
            setAllowed(false)
            setDataModal(setErrorWindow(
                '',
                0,
                lang.messages[`code_${validPassword.code}`])
            )
            return
        }

        const validEmail = validationEmail(form.email)

        if (!validEmail.flag) {
            setAllowed(false)
            setDataModal(setErrorWindow(
                '',
                0,
                lang.messages[`code_${validEmail.code}`])
            )
            return
        }

        const encodedEmail = btoa(form.email.toLowerCase())
        const encodePassword = btoa(validPassword.res)

        try {

            const data = await request(
                `${host}/api/user/login`,
                'POST',
                {
                    email: encodedEmail,
                    password: encodePassword,
                    deviceId: deviceId
                }
            )

            if ((data.status > 201 || data.status < 200)) {

                setAllowed(false)

                let clickOk = '', clickCancel = '', btnOK = '', btnCancel = ''

                if (data.code === 609 || data.code === 613) {
                    btnOK = lang.modal.errors.btnOK
                    clickOk = `replaceTo /${l}/verify?uid=${data.userId}`
                    btnCancel = lang.modal.errors.btnCancel
                    clickCancel = 'replaceToMain'
                }
                else if (data.code === 604) {
                    clickOk = `replaceTo /${l}/restore`
                    btnOK = lang.modal.errors.btnRestore
                    btnCancel = lang.modal.errors.btnAgain
                    clickCancel = 'replaceToAuth'
                }

                setDataModal(setErrorWindow(
                    lang.modal.errors.title,
                    data.code,
                    lang.messages[`code_${data.code}`],
                    btnOK,
                    clickOk,
                    btnCancel,
                    clickCancel
                ))

                return
            }

            if (!data.isActivated) {
                window.location.replace(`/${l}/verify?uid=${data.userId}`)
            }
            else {
                logging(l, auth, data, deviceId)
            }

        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }

    if (loading) {
        return <LoaderClass/>
    }

    if (!allowed) {
        return (
            <>
                <ModalWin data={dataModal}/>
            </>
        )
    }

    return (
        <>
            <div className={'pt-3 d-flex flex-wrap justify-content-center'}>
                <div className={'d-flex w-100 justify-content-center'}>
                    <h1 className={'mb-4 text-center fw-bold'}>
                        {lang.body.authPage.title}
                    </h1>
                </div>

                <form
                    id={'authorization-form'}
                    className={'mt-1 mb-2 ps-3 pe-3 d-flex justify-content-center rounded-5'}
                    style={{minWidth: widthWin}}
                >

                    <fieldset className={'teal p-3 border border-dark-subtle border-opacity-25 rounded-3 w-100'}>

                        <div className={'ps-1 pe-3 d-flex align-items-center'}>

                            <legend id={"legend"} className={'fs-3 col col-7'}>
                                {lang.body.authPage.titleButton}
                            </legend>

                            <Button
                                className={'m-3 ps-2 pe-2 p-0 fs-5 col col-5 btn-light border-opacity-25 border-black'}
                                onClick={() => {
                                    navigate(`/${lang.lang}/auth-social`, { replace: true })
                                    // window.location.replace(`/${lang.lang}/auth-social`)
                                }}
                            >
                                {lang.body.authPage.buttonSocial}
                            </Button>

                        </div>

                        <div id={"divEmail"} className={"mb-3"}>

                            <label htmlFor={"email"} className={"form-label"}>
                                {lang.body.authPage.labelEmail}
                            </label>

                            <input
                                type={"text"}
                                name={"email"}
                                id={"email"}
                                value={form.email}
                                onChange={changeHandler}
                                className={"form-control"}
                                placeholder={lang.body.authPage.placeholderEmail}
                            />

                        </div>

                        <div id={"divPassword"} className={"mb-3"}>

                            <label
                                id={"label-password"}
                                htmlFor={"password"}
                                className={"form-label"}
                            >
                                {lang.body.authPage.labelPassword}
                            </label>

                            <div className={"input-group"}>

                                <input
                                    type={"password"}
                                    name={"password"}
                                    id={"password"}
                                    value={form.password}
                                    onChange={changeHandler}
                                    className={"form-control"}
                                    placeholder={lang.body.authPage.placeholderPassword}
                                />

                                <div className={"input-group-prepend"}>
                                    <div className={"div-eye input-group-text"}>

                                        <Link
                                            to={``}
                                            className={"eye-auth"}
                                            onClick={() => {
                                                eyeHandler($('#eye-open-close'), $('#password'))
                                            }}
                                        >
                                            <i id={"eye-open-close"} className={"fa-regular fa-eye-slash"}/>
                                        </Link>

                                    </div>
                                </div>

                            </div>

                        </div>

                        <div className={"container d-flex justify-content-center"}>
                            <div className={"row"}>
                                <div className={"col-sm d-flex justify-content-center"}>

                                    <button
                                        id={"enter"}
                                        type={'button'}
                                        onClick={loginHandler}
                                        disabled={loading}
                                        className={"mt-2 btn btn-primary"}
                                    >
                                        {lang.body.authPage.btnLogin}
                                    </button>

                                    <button
                                        id={"sendAgain"}
                                        type={'button'}
                                        onClick={sendSmsHandler}
                                        disabled={loading}
                                        className={"mt-2 btn btn-primary d-none"}
                                    >
                                        {lang.body.authPage.getCodeAgain}
                                    </button>

                                    <button
                                        id={"enterAgain"}
                                        type={'button'}
                                        onClick={enterAgainHandler}
                                        disabled={loading}
                                        className={"mt-2 btn btn-primary d-none"}
                                    >
                                        {lang.body.authPage.inToAnotherAccount}
                                    </button>

                                    <button
                                        id={"remindPass"}
                                        type={'button'}
                                        onClick={remindPassHandler}
                                        disabled={loading}
                                        className={"mt-2 ms-2 btn btn-warning ms-1"}
                                    >
                                        {lang.body.authPage.restorePassword}
                                    </button>

                                </div>
                            </div>
                        </div>

                    </fieldset>

                </form>
            </div>
        </>
    )
}